/* global Team */
var News = function() {
    var registerNewsitemClickHandler = function() {
        $('.news').click(function() {
            window.location.href = $(this).find('a').attr('href');
        });
    };

    var init_scroll_more = function(desktop_newspage, inf_scroll_offset) {
        News.loading_more = false;

        $(window).scroll(function() {
            if ($(window).scrollTop() + inf_scroll_offset < $(document).height() - $(window).height() || News.loading_more) {
                return;
            }
            News.loading_more = true;
            if (desktop_newspage) {
                Ajax.getNewspageArticles(
                    encodeURIComponent($('#morenews').data('excluded_news')),
                    $('#morenews').data('news_offset'),
                    $('#morenews').data('prs_offset'),
                    function(res) {
                        if (res.success == 'ok') {
                            if (res.news_html && res.news_offset) {
                                $('#rest_news').append(res.news_html);
                                $('#morenews').data('news_offset', res.news_offset);
                            }
                            if (res.prs_html && res.prs_offset) {
                                $('#prs').append(res.prs_html);
                                $('#morenews').data('prs_offset', res.prs_offset);
                            }
                            News.loading_more = false;
                        }
                    }
                );
            } else {
                Ajax.getMoreNews(
                    $('#morenews').data('tag'),
                    $('#morenews').data('team'),
                    $('#morenews').data('fdate'),
                    function(res) {
                        if (res.success == 'ok' && res.html) {
                            var parent = $('#morenews').parent();
                            $('#morenews').remove();
                            parent.append(res.html);
                            if (Generic.mobile) { // in desktop this breaks middle click, team click etc
                                registerNewsitemClickHandler();
                            }
                            News.loading_more = false;
                        }
                    }
                );
            }
        });
    };

    return {
        init: function(desktop_newspage = false, inf_scroll_offset = 1300) {
            if ($('#showmoreteamsbtn').length > 0) {
                $('#showmoreteamsbtn').click(function() {
                    $('.team-logo-news').show();
                    $('#showmoreteamsbtn').hide();
                });
            }
            if ($('#morenews').length > 0) {
                init_scroll_more(desktop_newspage, inf_scroll_offset);
                if (Generic.mobile) { // in desktop this breaks middle click, team click etc
                    registerNewsitemClickHandler();
                }
            }
        }
    };
}();
